/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Component, Inject, Input, signal} from '@angular/core';
import {deferSignalStateWrite} from '../common/util/template-state';
import * as _ from 'lodash';

import template from './copy-from-line-item.component.html';
import {LineItemApiService} from '../line-item/line-item-api.service';
import {SearchApiService} from '../common/controller/search-api.service';

@Component({
  standalone: false,
  selector: 'adn-copy-from-line-item',
  template
})
export class CopyFromLineItemComponent {
  @Input() targeting: any;
  @Input() tabController: any;

  lineItem: any = {};
  readonly lineItemResults = signal<any[]>([]);
  readonly liTargeting = signal<any>(null);
  readonly pending = signal(false);
  readonly initialised = signal(false);

  readonly copyHook: any = {
    copy: (target: any) => {
      const copied = _.cloneDeep(this.liTargeting()?.[target.targets]);
      if (_.isFunction(this.tabController?.copyTargetingTemplate)) {
        this.tabController.copyTargetingTemplate(
          target.widget,
          {data: {model: copied}},
          () => this.targeting[target.targets] = copied
        );
      } else {
        this.targeting[target.targets] = copied;
      }
      this.copyHook.results(target, true);
    }
  };

  readonly searchLineItems = (searchElement: any) => {
    this.searchApi.search({q: searchElement.search, types: 'LineItem'}).subscribe({
      next: (data) => this.lineItemResults.set(data?.searchResults || []),
      error: () => this.lineItemResults.set([])
    });
  };

  constructor(
    private readonly searchApi: SearchApiService,
    @Inject(LineItemApiService) private readonly LineItem: LineItemApiService
  ) {
  }

  lineItemSelected(): void {
    this.pending.set(true);
    this.initialised.set(true);
    if (_.isFunction(this.copyHook.clear)) {
      this.copyHook.clear();
    }
    firstValueFrom(this.LineItem.get(this.lineItem.id)).then((results: any) => {
      deferSignalStateWrite(() => {
        this.liTargeting.set(results.targeting);
        this.pending.set(false);
      });
    }, () => {
      deferSignalStateWrite(() => {
        this.liTargeting.set(null);
        this.pending.set(false);
      });
    });
  }
}
